import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "grid wf-tariffs mb-6" }
const _hoisted_2 = { class: "lg:col-7 sm-12 mb-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", { class: "text-normal m-0 wf-bg-green-500 wf-color-green-50 p-3" }, " Стандартный пакет ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus mr-3 wf-color-green-500" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-check mr-3 wf-color-green-500" }, null, -1)
const _hoisted_6 = { class: "lg:col-5 sm-12 mb-4" }
const _hoisted_7 = { class: "text-normal m-0  wf-bg-pink-500 wf-color-pink-50 p-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus mr-3 wf-color-green-500" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus mr-3 wf-color-green-500" }, null, -1)
const _hoisted_10 = { class: "col-12 flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Card, { class: "wf-bg-blue-50" }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        content: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tariffs[1].bonuses, (bonus) => {
            return (_openBlock(), _createBlock("div", {
              class: "wf-list-item wf-fw-600 wf-bg-green-50 wf-color-green-700",
              key: bonus
            }, [
              _hoisted_4,
              _createVNode("span", { innerHTML: bonus }, null, 8, ["innerHTML"])
            ]))
          }), 128)),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tariffs[1].includes, (include) => {
            return (_openBlock(), _createBlock("div", {
              class: "wf-list-item wf-fw-600",
              key: include
            }, [
              _hoisted_5,
              _createVNode("span", { innerHTML: include }, null, 8, ["innerHTML"])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Card, { class: "wf-bg-blue-50" }, {
        header: _withCtx(() => [
          _createVNode("h4", _hoisted_7, "Бонусы при заключении договора до 31 " + _toDisplayString(_ctx.month), 1)
        ]),
        content: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tariffs[2].includes, (include) => {
            return (_openBlock(), _createBlock("div", {
              class: "wf-list-item wf-fw-600",
              key: include
            }, [
              _hoisted_8,
              _createVNode("span", { innerHTML: include }, null, 8, ["innerHTML"])
            ]))
          }), 128)),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tariffs[3].includes, (include) => {
            return (_openBlock(), _createBlock("div", {
              class: "wf-list-item wf-fw-600",
              key: include
            }, [
              _hoisted_9,
              _createVNode("span", { innerHTML: include }, null, 8, ["innerHTML"])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_Button, {
        label: "Оставить заявку",
        icon: "pi pi-envelope",
        class: "p-button-lg shadow-8 mt-4",
        onClick: _ctx.proceedToOrder
      }, null, 8, ["onClick"])
    ])
  ]))
}